import { render, staticRenderFns } from "./FaqSearchResult.vue?vue&type=template&id=be888aac&scoped=true&lang=pug&"
import script from "./FaqSearchResult.vue?vue&type=script&setup=true&lang=js&"
export * from "./FaqSearchResult.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FaqSearchResult.scss?vue&type=style&index=0&id=be888aac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be888aac",
  null
  
)

export default component.exports